export default function TimeIcon() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0.875C5.37572 0.875 3.8178 1.52032 2.66868 2.66868C1.52025 3.81766 0.875 5.37572 0.875 7C0.875 8.62428 1.52032 10.1822 2.66868 11.3313C3.81766 12.4798 5.37572 13.125 7 13.125C8.62428 13.125 10.1822 12.4797 11.3313 11.3313C12.4798 10.1823 13.125 8.62428 13.125 7C13.125 5.37572 12.4797 3.8178 11.3313 2.66868C10.1823 1.52025 8.62428 0.875 7 0.875ZM10.0143 8.50934C9.93997 8.65645 9.78957 8.74941 9.62497 8.74997C9.55607 8.75107 9.4888 8.73411 9.4281 8.70185L6.8031 7.38935C6.65599 7.31497 6.56303 7.16458 6.56247 6.99998V3.06248C6.56247 2.82075 6.75825 2.62498 6.99997 2.62498C7.2417 2.62498 7.43747 2.82075 7.43747 3.06248V6.7288L9.82181 7.92317C10.0362 8.03254 10.1226 8.29449 10.0143 8.50942L10.0143 8.50934Z"
        fill="#FFFFF2"
      />
    </svg>
  );
}

export function StoriesTimeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M6.49476 2.84082C6.24279 2.84082 6.04102 3.0426 6.04102 3.29457V6.20455C6.04102 6.36843 6.12911 6.53231 6.28018 6.6076L7.792 7.4014C7.85499 7.43929 7.93078 7.4516 8.00607 7.4516C8.16995 7.4516 8.32103 7.36351 8.40912 7.21243C8.52231 6.98556 8.44701 6.72129 8.22014 6.59531L6.94745 5.92749L6.94794 3.29417C6.94794 3.0422 6.73394 2.84082 6.49476 2.84082Z"
        fill="#FFFFF2"
      />
      <path
        d="M0.177102 6.63259C0.353279 6.80876 0.643143 6.80876 0.819824 6.63259L1.36117 6.07846C1.39906 8.98895 3.76772 11.3447 6.67758 11.3447C9.61314 11.3447 12.0068 8.95103 12.0068 6.01547C12.0068 3.07991 9.61314 0.686207 6.67758 0.686206C6.42561 0.686206 6.22383 0.887983 6.22383 1.13995C6.22383 1.39192 6.42561 1.5937 6.67758 1.5937C9.1092 1.5937 11.087 3.57152 11.087 6.00315C11.087 8.43477 9.1092 10.4126 6.67758 10.4126C4.27102 10.4126 2.30605 8.47269 2.26813 6.07899L2.80996 6.62082C2.98613 6.797 3.276 6.797 3.45268 6.62082C3.62886 6.44464 3.62886 6.15478 3.45268 5.9781L2.12985 4.65526C2.04176 4.56717 1.92807 4.51648 1.80208 4.51648C1.6761 4.51648 1.57521 4.56668 1.47432 4.65526L0.15149 5.9781C-0.0118995 6.16658 -0.0118766 6.45641 0.177102 6.63259Z"
        fill="#FFFFF2"
      />
      <path
        d="M5.25405 1.87152C5.50601 1.78343 5.6448 1.50637 5.55621 1.2544C5.46812 1.00243 5.19105 0.863649 4.93909 0.952241C4.68712 1.04033 4.54833 1.31739 4.63692 1.56936C4.72502 1.83364 5.00208 1.95962 5.25405 1.87152Z"
        fill="#FFFFF2"
      />
      <path
        d="M3.93131 2.61416C4.14539 2.43799 4.17048 2.13532 4.0071 1.92125C3.83093 1.70718 3.52826 1.68208 3.31419 1.84546C3.10012 2.02164 3.07502 2.3243 3.2384 2.53837C3.40228 2.75294 3.71724 2.77803 3.93131 2.61416Z"
        fill="#FFFFF2"
      />
      <path
        d="M2.25571 3.92432C2.48258 4.0631 2.78474 3.98731 2.92352 3.76044C3.06231 3.53356 2.98652 3.2314 2.75964 3.09262C2.53277 2.95383 2.23061 3.02963 2.09183 3.2565C1.95304 3.48337 2.02883 3.78602 2.25571 3.92432Z"
        fill="#FFFFF2"
      />
    </svg>
  );
}

export function TimeIconLarge() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_64603_10863)">
        <path
          d="M10.0045 0.831299C4.95125 0.831299 0.831055 4.9517 0.831055 10.0047C0.831055 15.0579 4.95145 19.1695 10.0045 19.1695C15.0569 19.1695 19.1693 15.0571 19.1693 10.0047V10.0039C19.1708 9.78204 19.0833 9.56798 18.9263 9.41016C18.7693 9.25313 18.5552 9.16484 18.3333 9.16562C18.1115 9.1664 17.8997 9.25546 17.7443 9.4125C17.5888 9.57031 17.5013 9.78282 17.5029 10.0039C17.5029 14.1563 14.1569 17.5023 10.0045 17.5023C5.85207 17.5023 2.49827 14.1563 2.49827 10.0039C2.49827 5.8515 5.85287 2.4977 10.0045 2.4977C10.4623 2.49614 10.8326 2.12504 10.8349 1.66724C10.8357 1.44614 10.7482 1.23442 10.5928 1.0774C10.4373 0.920365 10.2256 0.832079 10.0045 0.831299ZM13.1669 1.45786C12.8419 1.46098 12.534 1.65551 12.4036 1.97504C12.2278 2.4016 12.4309 2.8891 12.8575 3.0641C12.8668 3.06801 12.8739 3.07347 12.8817 3.07738C13.3083 3.25785 13.8005 3.05629 13.977 2.62816C14.1536 2.20316 13.952 1.71644 13.5278 1.5391C13.5161 1.53441 13.5028 1.52582 13.4919 1.52113C13.3856 1.47738 13.2747 1.45629 13.1661 1.45785L13.1669 1.45786ZM15.8787 3.26098C15.6591 3.26254 15.449 3.35082 15.2943 3.50708C14.9669 3.83286 14.9669 4.36332 15.2943 4.68912C15.3013 4.69615 15.3052 4.70006 15.3122 4.70709C15.6365 5.03599 16.1661 5.03913 16.4943 4.71334C16.8216 4.38756 16.8216 3.8571 16.4943 3.5313C16.4857 3.5227 16.4787 3.51489 16.4701 3.50708C16.3138 3.35005 16.1013 3.26176 15.8794 3.26098L15.8787 3.26098ZM10.0045 4.16566C9.78179 4.16488 9.56851 4.25238 9.41069 4.40942C9.25366 4.56645 9.16537 4.77974 9.16615 5.00238V10.004C9.16693 10.3196 9.34584 10.6071 9.62865 10.7477L12.9623 12.4141V12.4149C13.1599 12.5141 13.3896 12.5305 13.5998 12.4602C13.8099 12.3899 13.9834 12.2384 14.0818 12.0399C14.181 11.8423 14.1974 11.6126 14.1271 11.4024C14.0568 11.1923 13.906 11.0188 13.7076 10.9204L10.835 9.48677V5.00237C10.8357 4.78127 10.7482 4.56877 10.5928 4.41253C10.4373 4.2555 10.2256 4.16644 10.0045 4.16566ZM17.6999 5.95784C17.5905 5.95706 17.4795 5.97815 17.3725 6.02268C16.9444 6.19925 16.7428 6.69144 16.9233 7.118C16.9272 7.12816 16.9327 7.13363 16.9366 7.14222C17.1108 7.56878 17.5991 7.77346 18.0256 7.59768C18.4522 7.42346 18.6569 6.93518 18.4811 6.50862C18.4764 6.4969 18.4725 6.48753 18.4678 6.47737C18.3373 6.15471 18.0272 5.95861 17.6999 5.95627V5.95784Z"
          fill="#C0B9B7"
        />
      </g>
      <defs>
        <clipPath id="clip0_64603_10863">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
